import React, { useEffect, useState } from 'react';
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, message, Popconfirm, Row, Select, Space, AutoComplete } from 'antd';
import { useGetAreaQuery, useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import { createJsonOptions } from '@/scripts/utils';
import { FORM_RULE_REQUIRED } from '@/scripts/config';
import LabelValueAutoComplete from '@/components/common/LabelValueAutoComplete';
import dayjs from 'dayjs';
import ajax from '@/scripts/ajax';
import axios from 'axios';
import _ from 'lodash';

const defaultValue = {
    account_num: 1,
    account_end: 50,
    quantity: ['1'],
    // cargo_details: 'Fabrics, textiles',
    send_num: 1,
    cid_type: 7,
    destination_service_mode: 'CY',
    // import_service_mode: 'CY',
    free_time_days: 0,
    account_name: '-1',
    limit_day: 7,
    origin_location: 'NingBo,104T898SJZ6GU',
    box_type: ['40 Dry High'],
    is_USA: undefined,
    is_roll: undefined,
    origincity_name: undefined,
    destinationcity_name: undefined,
    order_date: dayjs(),
    route_select: undefined,
    get_cid_times: undefined,
    cid_loop_times: undefined,
    cid_concurrent: undefined,
    cid_sleep: undefined,
    nac_loop_times: undefined,
    nac_times: undefined,
    nac_concurrent: undefined,
    nac_sleep: undefined,
    booking_number: undefined,
    customer_code: undefined,
};
const serviceModeOptions = [
    { label: 'CY', value: 'CY' },
    { label: 'SD', value: 'SD' },
];
const cidTypeOptions = [
    { label: '常规下单', value: 0 },
    { label: '模式下单', value: 1 },
    { label: '模式下单2', value: 2 },
    { label: '模式下单3', value: 3 },
    { label: '模式下单4', value: 4 },
];
export default function BookOrderListForm(props) {
    const { id, cache, onValueChange } = props;
    const [form] = Form.useForm();

    const { data: startPortOptions } = useGetStartPortQuery(1);
    const { data: endPortOptions } = useGetEndPortQuery(1);
    // const { data: areaOptions } = useGetAreaQuery();
    const [submitting, setSubmitting] = useState(false);
    const [formDefaultValue, setFormDefaultValue] = useState(null);
    const yesNoOptions = [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
    ];
    useEffect(() => {
        let finalValue = { ...defaultValue };

        if (cache) {
            const cacheCopy = { ...cache };
            if (cacheCopy.box_type !== undefined) {
                if (typeof cacheCopy.box_type === 'string') {
                    cacheCopy.box_type = cacheCopy.box_type.split(',').filter(Boolean);
                }
            }
            if (cacheCopy.quantity !== undefined) {
                if (typeof cacheCopy.quantity !== 'object') {
                    cacheCopy.quantity = String(cacheCopy.quantity).split(',').filter(Boolean);
                }
            }
            if (cacheCopy.order_date) {
                const parsed = dayjs(cacheCopy.order_date);
                cacheCopy.order_date = parsed.isValid() ? parsed : dayjs();
            }

            finalValue = { ...finalValue, ...cacheCopy };
        }
        setFormDefaultValue(finalValue);
    }, [cache]);

    const handleSubmit = () => {
        form.validateFields()
            .then((formValue) => {
                setSubmitting(true);
                const { order_date, ...rest } = formValue;
                const value = {
                    order_date: dayjs(order_date).format('YYYY-MM-DD'),
                    ...rest,
                    box_type: Array.isArray(rest.box_type) ? rest.box_type.join(',') : rest.box_type,
                    quantity: Array.isArray(rest.quantity) ? rest.quantity.join(',') : String(rest.quantity),
                };
                // console.log(value, 'submit value');
                axios
                    .post('http://183.249.91.105:15600/book/submit', value)
                    .then((response) => {
                        message.success('订舱提交成功');
                    })
                    .catch((err) => {
                        message.error('订舱提交失败');
                    })
                    .finally(() => {
                        setSubmitting(false);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleReset = () => {
        form.resetFields();
        form.setFieldsValue({ ...defaultValue });
        onValueChange(id, { ...defaultValue });
    };

    const handleDelete = () => {
        onValueChange(id, 'delete');
    };

    const handleValueChange = async () => {
        const formValue = await form.getFieldsValue();
        onValueChange(id, formValue);
    };

    if (!formDefaultValue) return null;

    return (
        <Form form={form} initialValues={formDefaultValue} onValuesChange={handleValueChange}>
            <Card style={{ minWidth: 1150 }}>
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label="启始港" name="start_port_en_name" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="目的港" name="end_port_en_name" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="日期" name="order_date">
                            <DatePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="账号" name="account_name">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="箱型" name="box_type">
                            <Select
                                mode="multiple"
                                options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                                showSearch
                                allowClear
                            ></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="路由" name="route_select">
                            <Input style={{ width: '80%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="订单" name="quantity">
                            <Select
                                mode="tags" // 标签输入
                                tokenSeparators={[',', ' ', '\n']} // 分隔符
                                placeholder="输入数字，用空格/逗号/回车分隔"
                                onKeyDown={(e) => {
                                    const key = e.key;
                                    if (
                                        !/^[0-9]$/.test(key) &&
                                        key !== 'Backspace' &&
                                        key !== 'Delete' &&
                                        key !== 'ArrowLeft' &&
                                        key !== 'ArrowRight' &&
                                        key !== 'Tab' &&
                                        key !== 'Enter' &&
                                        key !== ',' &&
                                        key !== ' ' &&
                                        key !== ';'
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="is_USA" name="is_USA">
                            <Select options={yesNoOptions} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <Form.Item label="模式" name="destination_service_mode">
                                <Select options={serviceModeOptions}></Select>
                            </Form.Item>
                        </div>
                    </Col>

                    <Col span={6}>
                        <Form.Item label="limit_day" name="limit_day">
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item label="is_roll" name="is_roll">
                            <Select options={yesNoOptions} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="cid类型" name="cid_type">
                            <LabelValueAutoComplete
                                style={{ width: '100%' }}
                                options={cidTypeOptions}
                                placeholder="选择或输入"
                                allowClear
                                showSearch
                            />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item label="cid循环次数" name="cid_loop_times">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="cid请求次数" name="get_cid_times">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="cid并发次数" name="cid_concurrent">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="cid间隔时间 " name="cid_sleep">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="nac循环次数 " name="nac_loop_times">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="nac请求次数 " name="nac_times">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="nac并发次数 " name="nac_concurrent">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="nac间隔时间 " name="nac_sleep">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="booking_number " name="booking_number">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="customer_code " name="customer_code">
                            <Input style={{ width: '100%' }}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="send_num" name="send_num">
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>
                </Row>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Space>
                        <Popconfirm title="确认" description="是否执行该操作?" onConfirm={handleDelete} okText="是" cancelText="否">
                            <Button danger ghost>
                                删除
                            </Button>
                        </Popconfirm>
                        <Button onClick={handleReset}>重置</Button>
                    </Space>

                    <Button onClick={handleSubmit} type="primary" loading={submitting}>
                        开始订舱
                    </Button>
                </div>
            </Card>
        </Form>
    );
}
